import { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Iconify from 'src/components/Iconify';
import v2_actionUploadS3 from 'src/actions/v2/global/actionUploadS3';

export default function ImageUploadField({ label, value, onChange, hint }) {
    const { t } = useTranslation('settings');
    const inputRef = useRef(null);
    const [uploading, setUploading] = useState(false);

    const handleFile = async (file) => {
        if (!file) return;
        setUploading(true);
        const formData = new FormData();
        formData.append('file', file);
        try {
            const res = await v2_actionUploadS3(formData, '?path=plataforma/widget-cms');
            const url = res?.data?.data?.location;
            if (url) onChange(url);
        } catch (e) {
            console.log('erro ao fazer upload da imagem', e);
        } finally {
            setUploading(false);
        }
    };

    return (
        <div>
            <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">{label}</label>
            <input
                ref={inputRef}
                type="file"
                accept="image/*"
                className="hidden"
                onChange={e => handleFile(e.target.files?.[0])}
            />
            {value ? (
                <div className="relative group rounded-xl overflow-hidden border border-gray-200">
                    <img src={value} alt={label} className="w-full h-32 object-cover" />
                    <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-2">
                        <button
                            type="button"
                            onClick={() => inputRef.current?.click()}
                            className="px-3 py-1.5 bg-white text-gray-800 text-xs font-medium rounded-lg"
                        >
                            {t('widgetCms.imageUpload.changeButton', 'Trocar')}
                        </button>
                        <button
                            type="button"
                            onClick={() => onChange('')}
                            className="px-3 py-1.5 bg-red-500 text-white text-xs font-medium rounded-lg"
                        >
                            {t('buttons.remove', 'Remover', { ns: 'common' })}
                        </button>
                    </div>
                </div>
            ) : (
                <button
                    type="button"
                    disabled={uploading}
                    onClick={() => inputRef.current?.click()}
                    className="w-full h-24 border-2 border-dashed border-gray-200 rounded-xl flex flex-col items-center justify-center gap-1 text-gray-400 hover:border-[#7C3AED]/40 hover:text-[#7C3AED] transition-colors"
                >
                    <Iconify icon={uploading ? 'eos-icons:loading' : 'eva:image-outline'} width={20} />
                    <span className="text-xs">{uploading ? t('widgetCms.imageUpload.uploadingLabel', 'Enviando...') : t('widgetCms.imageUpload.clickToUpload', 'Clique para enviar imagem')}</span>
                </button>
            )}
            {hint && <p className="text-[11px] text-gray-400 mt-1.5">{hint}</p>}
        </div>
    );
}

ImageUploadField.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    hint: PropTypes.string
};
